'use client'

import { useState } from 'react'
import { Card, CardContent, CardHeader, FormControl, FormControlLabel, IconButton, Paper, Radio, RadioGroup, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import ButtonShowcase from 'common/demo/components/_buttonShowcase'
import CheckboxesShowcase from 'common/demo/components/_checkboxsShowcase'
import DatePickersShowcase from 'common/demo/components/_datepickerShowcase'
import DialogShowcase from 'common/demo/components/_dialogsShowcase'
import InputShowcase from 'common/demo/components/_inputsShowcase'
import RadiosShowcase from 'common/demo/components/_radiosShowcase'
import ToastShowcase from 'common/demo/components/_toastsShowcase'
import TableShowcase from 'common/demo/components/_tableShowcase'

export default function ComponentsShowcase() {
    const [size, setSize] = useState<"small" | "medium">("small")

    return (
        <Card>
            <CardHeader title='Components Showcase' />
            <CardContent>
                <Stack spacing={2}>
                    <FormControl component="fieldset">
                        <RadioGroup
                            row
                            value={size}
                            onChange={(e) => setSize(e.target.value as "small" | "medium")}
                        >
                            <FormControlLabel value="small" control={<Radio />} label="Small" />
                            <FormControlLabel value="medium" control={<Radio />} label="Medium" />
                        </RadioGroup>
                    </FormControl>

                    <InputShowcase size={size} setSize={setSize}/>
                    <DatePickersShowcase size={size}/>
                    <RadiosShowcase size={size}/>
                    <CheckboxesShowcase size={size}/>
                    <ButtonShowcase size={size}/>
                    <DialogShowcase size={size}/>
                    <ToastShowcase size={size} />
                    <TableShowcase />
                </Stack>
            </CardContent>
        </Card>
    )
}
